import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  close: {
    id: 'react-components.rbrahO',
    defaultMessage: 'Close',
  },
});
